// src/components/ui/Badge.jsx

import { cn } from "../../../lib/utils";

const colors = {
  success: 'bg-green-100 text-green-800',
  warning: 'bg-yellow-100 text-yellow-800',
  danger: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  primary: 'bg-primary/10 text-primary',
};

export default function BadgeResource({ children, variant = 'info', className }) {
  return (
    <span className={cn('px-3 py-1 rounded-full text-xs font-medium', colors[variant], className)}>
      {children}
    </span>
  );
}